const envUrl = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_RUTA_WEB) ? process.env.REACT_APP_RUTA_WEB : null;
const originUrl = window.location.origin;
const baseURL = String(envUrl || originUrl).replace(/\/+$/,'');
export default baseURL;
